import { TYPE_STRING } from './input-types';

export const id = 'postalCode';
export const apiKey = 'PostalCode';
export const type = TYPE_STRING;

export const postalCode = {
  id,
  apiKey,
  type,
};
